export default __webpack_public_path__ + "static/slider-image-1-f136282bf6cc34566be7a2c4afebedbf.png";